export const ADMIN_FEATURE_CODES = Object.freeze({
  simManagement: 'SIM_SCHEMA_PENDING',
  stewardChangeWorkflow: 'STEWARD_CHANGE_SCHEMA_PENDING'
});

export const isAdminFeatureUnavailableError = (error, expectedCode) => (
  error?.response?.status === 503
  && error?.response?.data?.code === expectedCode
);

export const readAdminFeatureAvailability = (response, featureKey) => {
  const feature = response?.data?.data?.[featureKey];
  if (!feature || typeof feature.enabled !== 'boolean') {
    throw new Error('Invalid admin capability response');
  }
  return feature;
};
